import React from 'react'

const SvgIconfinderSocialMediaSocialMediaLogoMixcloud1907109 = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g data-name="<Group>" fill="none" stroke="#303c42" strokeLinecap="round" strokeLinejoin="round">
      <g data-name="<Group>">
        <path
          d="M14.5 10.5a5 5 0 0 0-9.91-.94A3.5 3.5 0 0 0 4 9.5a3.5 3.5 0 0 0 0 7h10.5a3 3 0 0 0 0-6zM1.53 10.53a3.5 3.5 0 0 1 4.95 0M11.36 5.86a5 5 0 0 1 2.79 6.5"
          data-name="<Path>"
        />
      </g>
      <path d="M19.61 16.65a5.94 5.94 0 0 0 0-6.3M22 18.5a9.08 9.08 0 0 0 0-10" data-name="<Path>" />
    </g>
  </svg>
)

export default SvgIconfinderSocialMediaSocialMediaLogoMixcloud1907109
